import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SettigCompanyComponent } from './settig-company.component';
import { HttpClientModule } from '@angular/common/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DialogModule } from 'primeng/dialog';
import { ButtonModule } from 'primeng/button';
import { DropdownModule } from 'primeng/dropdown';
import { InputTextModule } from 'primeng/inputtext';
import { MessagesModule } from 'primeng/messages';
import { TableModule } from 'primeng/table';
import { ViewVersionModule } from '../view-version/view-version.module';
import { LoadingComponent } from '../loading/loading.component';



@NgModule({
  declarations: [SettigCompanyComponent],
  imports: [
    CommonModule,
    HttpClientModule,
    FormsModule,
    ReactiveFormsModule,
    LoadingComponent,
    DialogModule,
    ButtonModule,
    DropdownModule,
    InputTextModule,
    MessagesModule,
    TableModule
  ],
  exports: [SettigCompanyComponent]
})
export class SettigCompanyModule { }
